<template>
    <nav class="container">
        <ul class="breadcrumb">
            <li class="breadcrumb-item">
                <router-link :to="{name: 'home'}">Start</router-link>
            </li>
            <li class="breadcrumb-item" v-if="$route.params.id && document">{{category.title}}</li>
            <li class="breadcrumb-item" v-if="$route.params.id && document">{{document.title}}</li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "Breadcrumb",
        props: [],
        computed: {
            document() {
                return this.$store.getters.documentById(this.$route.params.id)
            },

            category() {
                return this.document ? this.$store.getters.categoryById(this.document.categoryId) : {};
            }
        }
    }
</script>

<style scoped lang="scss">
    .breadcrumb {
        list-style-type: none;
        font-size: 1.6rem;
    }

    .breadcrumb-item {
        display: inline-block;

        &:not(:last-child) {
            &:after {
                content: "→";
                margin-left: 1.5rem;
            }
            margin-right: 1.5rem;
        }
    }

</style>